import { type GuaranteedRewardProps } from './GuaranteedReward';

import starPng from '/img/icons/star-large.png';
import starWebp from '/img/icons/star-large.webp';
import goldTicketPng from '/img/icons/ticket-gold.png';
import goldTicketWebp from '/img/icons/ticket-gold.webp';
import silverTicketPng from '/img/icons/ticket-silver.png';
import silverTicketWebp from '/img/icons/ticket-silver.webp';

const rewardList: GuaranteedRewardProps[] = [
  {
    id: '3',
    picture: {
      alt: 'silver ticket',
      img: silverTicketPng,
      webp: silverTicketWebp,
    },
    className: 'flex-row-reverse',
    title: {
      text: 'Soon',
      className: '!text-right',
    },
    description: {
      text: 'Silver',
      className: 'text-right',
    },
  },
  {
    id: '4',
    picture: {
      alt: 'gold ticket',
      img: goldTicketPng,
      webp: goldTicketWebp,
    },
    title: {
      text: 'Soon',
      className: '',
    },
    description: {
      text: 'Gold',
      className: '',
    },
  },
  {
    id: '1',
    picture: {
      alt: 'stars',
      img: starPng,
      webp: starWebp,
    },
    className: 'flex-row-reverse',
    title: {
      text: '',
      className: '!text-gold text-right',
    },
    description: {
      text: 'Every contract',
      className: '!text-right',
    },
  },
  {
    id: '2',
    picture: {
      alt: 'stars',
      img: starPng,
      webp: starWebp,
    },
    className: '',
    title: {
      text: '',
      className: '!text-gold',
    },
    description: {
      text: 'Every contract',
    },
  },
];

export { rewardList };
